import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Filters from "./filters/Filters";
import StoryResults from "./results/StoryResults";
import {
  fetchFilters,
  setIsUpdatedFromUrl,
  resetAllFilters,
} from "../redux/filters/filterSlice";
import { updateCurrentPageFromUrl } from "../redux/pagination/paginationSlice";
import { fetchLocalization } from "../redux/localization/localizationSlice";

function Stories() {
  const dispatch = useDispatch();
  const results = useSelector((state) => state.story.items);
  const filterGroups = useSelector((state) => state.filters.items);
  const isKidsApp = useSelector((state) => state.settings.isKidsApp);
  const dictionary = useSelector((state) => state.localization.dictionary);

  useEffect(() => {
    window.addEventListener("popstate", onPopstateEvent);
    dispatch(updateCurrentPageFromUrl());
    dispatch(fetchLocalization());
  }, []);

  const showingResultsMessage = useMemo(() => {
    let key = "";
    let selectedThemes = "";

    if (!isKidsApp) {
      selectedThemes = getSelectedThemes();

      if (selectedThemes.length >= 1 && results.totalElements === 1) {
        key = "CNHS.Filter.ResultWithThemes";
      } else if (selectedThemes.length >= 1 && results.totalElements !== 1) {
        key = "CNHS.Filter.ResultsWithThemes";
      } else if (selectedThemes.length === 0 && results.totalElements === 1) {
        key = "CNHS.Filter.ResultWithoutThemes";
      } else if (selectedThemes.length === 0 && results.totalElements !== 1) {
        key = "CNHS.Filter.ResultsWithoutThemes";
      }
    } else {
      key = "CNHS.Filter.ResultsWithoutThemes";
    }

    let result = dictionary[key];
    if (result) {
      const messageArgs = [results.totalElements, selectedThemes];

      result = result.replace(/{(\d+)}/g, (match, index) => {
        return typeof messageArgs[index] !== "undefined"
          ? messageArgs[index]
          : match;
      });
    }

    return result;
  }, [results?.totalElements, filterGroups]);

  function getSelectedThemes() {
    if (!filterGroups.length) {
      return [];
    }

    const selectedThemes = filterGroups
      .find((group) => group.name === "themes")
      .filters.filter((item) => item.selected);

    return selectedThemes.map((theme) => `'${theme.name}'`).join(", ");
  }

  function onPopstateEvent() {
    dispatch(resetAllFilters());
    dispatch(setIsUpdatedFromUrl(false));
    dispatch(updateCurrentPageFromUrl());
    dispatch(fetchFilters());
  }

  return (
    <>
      <div className="row">
        <div className="large-12 columns">
          <div className="showing">{showingResultsMessage}</div>
        </div>
      </div>
      <div className="row">
        <div className="large-4 columns">
          <Filters />
        </div>
        <div className="large-8 columns" aria-live="polite">
          <StoryResults />
        </div>
      </div>
    </>
  );
}

export default Stories;
